import { TFunction } from "i18next";
import {
  discountUnitFor,
  displayValue
} from "@/pages/contracts/components/updateTerms/changeDisplayValue";
import { TermsFieldChange } from "@/pages/contracts/components/updateTerms/types";

const DISCOUNT_AMOUNT = "discountAmount";
const DISCOUNT_UNIT = "isDiscountPercentage";

// One side of one changed field, as the history shows it.
//
// A discount amount is a percentage or a currency amount, and the field alone
// does not say which. The editor knows because it holds the row; this payload
// carries the unit only when the unit itself moved. Where it did not, the
// amount renders bare rather than being decorated with a unit we would be
// guessing at — showing "10" as "$10" when the row means 10% is worse than
// showing "10".
export const changeValueText = (
  change: TermsFieldChange,
  side: "before" | "after",
  siblingChanges: TermsFieldChange[],
  currency: string | null,
  t: TFunction
): string => {
  const unitMoved = siblingChanges.some(
    (sibling) => sibling.field === DISCOUNT_UNIT
  );
  const value = change[side];

  if (change.field === DISCOUNT_AMOUNT && !unitMoved) {
    return value == null || value === "" ? "—" : String(value);
  }

  return displayValue(value, change.field, {
    t,
    currency,
    isDiscountPercentage: discountUnitFor(siblingChanges, side, false)
  });
};
